import {Component, Input, OnInit} from '@angular/core';

export interface IColumnChartData {
  plan: number;
  plannedRedemptionGCB: number;
  purchasedGCB: number;
  canceledGCB: number;
  amountUnderContract: number;
  spentForConstructing: number;
  balanceFromSale: number;
  balanceGCB: number;
}

@Component({
  selector: 'app-column-money-chart',
  templateUrl: './column-money-chart.component.html',
  styleUrls: ['./column-money-chart.component.scss']
})

export class ColumnMoneyChartComponent implements OnInit {

    @Input() chartData: IColumnChartData = null;

    constructor() { }

    ngOnInit() {
        if(this.chartData === null || this.chartData === undefined){
            this.chartData = {
                plan: 0,
                plannedRedemptionGCB: 0,
                purchasedGCB: 0,
                canceledGCB: 0,
                amountUnderContract: 0,
                spentForConstructing: 0,
                balanceFromSale: 0,
                balanceGCB: 0,
            };
        }
    }                                                                                                 

    heightCalculate(amount: number, baseNumber: number): string {
        if (baseNumber === 0) {
            return '0';
        }
        return String(amount / baseNumber * 100) + '%';
    }

    round(number, count): number {
        return (Math.round(number * Math.pow(10, count)) / Math.pow(10, count));
    }

    summFormat(summ: number):string {
        let formSumm='-';
        if(summ!==null){
            formSumm = String(Math.round(summ*10)/10).replace('.', ',');
            if(formSumm.indexOf(',')===-1){
                formSumm=formSumm+',0'
            }
        }
        return formSumm;
    }

}
